export default __webpack_public_path__ + "static/media/b3.e9429b2a.jpg";